var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('components.modals.company.exportImplementation.title'),"action":"export","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('p',[_vm._v(_vm._s(_vm.$t('components.modals.company.exportImplementation.description')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }